import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

//main server url
//export const baseURL = "https://81.69.244.127:8443/web/api";
 export const baseURL = "https://cu1.hyperq.xyz:8443/web/api";

export const contentTYPE_JSON = "application/json"

// 登录请求方法
const loginreq = (method, url, params ) => {
  return axios({
    baseURL: baseURL,
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: params,
    traditional: true,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
  }).then((res) => res.data);
};
// 通用公用方法
const req = (method, url, data, contentType = "application/x-www-form-urlencoded") => {
  if(method == "get"){
    //get请求 data存入 params；
    return axios({
      baseURL: baseURL,
      method: method,
      url: url,
      headers: {
        "Content-Type": contentType,
        Authorization: sessionStorage.getItem("logintoken"),
      },
      params: data,
      traditional: true,
    }).then((res) => res.data);
  } 
  else if (method == "post") {
    //get请求 data存入 data；
    return axios({
      baseURL: baseURL,
      method: method,
      url: url,
      headers: {
        "Content-Type": contentType,
        Authorization: sessionStorage.getItem("logintoken"),
      },
      data: data,
      traditional: true,
    }).then((res) => res.data);
  }else{
    return null
  }
  
};

// 通用公用方法
const reqGetWithParams = (method, url, params) => {
  return axios({
    baseURL: baseURL,
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: sessionStorage.getItem("logintoken"),
    },
    params: params,
    traditional: true,
  }).then((res) => res.data);
};

// 通用公用方法
const reqPostWithData = (method, url, params) => {
  return axios({
    baseURL: baseURL,
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: sessionStorage.getItem("logintoken"),
    },
    params: params,
    traditional: true,
  }).then((res) => res.data);
};

// 通用公用方法
const reqPostForDownload = (method, url) => {
  return axios({
    baseURL: baseURL,
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: sessionStorage.getItem("logintoken"),
    },
    responseType: 'blob', 
    params: { 
      excel: 'excel02'
    },
    traditional: true,
  }).then((res) => res.data);
};

export { loginreq, req, reqGetWithParams, reqPostWithData , reqPostForDownload, axios };
